
import AppLayoutVue from "@/Layouts/AppLayout.vue";
import { CashRegister } from "@/types/CashRegister";
import { defineComponent, PropType, ref } from "vue";
import Card from "@/Components/General/Card.vue";
import Button from "@/Components/Buttons/Button.vue";
import TextButton from "@/Components/Buttons/TextButton.vue";
import { useForm } from "@inertiajs/inertia-vue3";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiChevronDown } from "@mdi/js";
import RegisterEditBox from "@/Components/CashRegisters/RegisterEditBox.vue";
import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition";
import Messages from "@/Components/General/Messages.vue";

export default defineComponent({
  layout: AppLayoutVue,
  props: {
    cashRegisters: {
      type: Object as PropType<CashRegister[]>,
      required: true,
    }
  },
  setup(props) {
    const showNewRegister = ref(false);

    const newRegister = () => {
      showNewRegister.value = true;
    }

    const abortNewRegister = () => {
      showNewRegister.value = false;
    }

    const form = useForm({
      name: "",
      terminal_is_mobile: false,
      terminal_id: "" as string | undefined,
      receipt_printer: "",
    });

    const sendForm = () => {
      if (form.terminal_is_mobile) {
        form.terminal_id = undefined;
      }

      form.post(route("cash-registers.store"), {
        onSuccess: () => {
          showNewRegister.value = false
          form.reset();
        }
      });
    }


    return {
      newRegister,
      abortNewRegister,
      showNewRegister,
      form,
      sendForm,
      arrowDownIcon: mdiChevronDown,
    }
  },
  components: { Card, Button, TextButton, SvgIcon, RegisterEditBox, CollapseTransition, Messages }
});
